import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography, useTheme, IconButton } from '@mui/material';
import dayjs from 'dayjs';
import IncidentTile from '@ui/components/IncidentTile';
import SectionHeader from '@ui/components/SectionHeader';
import useAlertsListStyles from './useAlertsStyles';
import { CustomDrawer } from '@ui/components/common';
import { between, colCenter } from '@ui/style/style';
import { ArrowRight24Regular, DismissRegular } from '@fluentui/react-icons';
import IncidentPreviewDrawer from '@ui/pages/Web/Incidents/components/IncidentPreviewDrawer';
import IncidentAPI from '@application/api/endpoints/incident-api';
import { formatDMY } from '@application/utilities/date-time-formater';
import { useDispatch } from 'react-redux';
import { fetchPreviewIncident } from '@application/redux/Incidents/incident-slice';
const Alerts = ({ open, handleClose, alerts, setAlerts }) => {
    const navigate = useNavigate();
    const [activeFilter, setActiveFilter] = useState('All');
    const theme = useTheme();
    const { ContentContainerStyles } = useAlertsListStyles();
    const [alertDetails, setalertDetails] = useState(false);
    const dispatch = useDispatch();
    const [sortValue, setSortValue] = useState('asc');
    const [filterValues, setFilterValues] = useState({
        range: [1.5, 10],
        startDate: dayjs(),
        endDate: dayjs()
    });
    const [FilteredAlert, setFilteredAlert] = useState([]);
    const [isLoading, setisLoading] = useState(false);
    const handleAlertTileClick = async (rowId) => {
        setisLoading(true);
        await dispatch(fetchPreviewIncident(rowId)).unwrap();
        setalertDetails(true);
        await IncidentAPI.updateIncidentAlerts(rowId);
        setisLoading(false);
    };
    const handleCloseAlerts = () => {
        handleClose();
        setActiveFilter('All');
    };
    useEffect(() => {
        const getIncidentAlerts = async () => {
            setisLoading(true);
            try {
                const response = await IncidentAPI.getIncidentAlerts();
                if (response.isSuccess && response?.data) {
                    setAlerts && setAlerts(response?.data);
                    setisLoading(false);
                }
            }
            catch (error) {
                setisLoading(false);
            }
        };
        getIncidentAlerts();
    }, [open, alertDetails]);
    useEffect(() => {
        activeFilter === 'All'
            ? setFilteredAlert(alerts?.allIncidentAlert)
            : setFilteredAlert(alerts?.criticalIncidentAlert);
    }, [activeFilter, alerts]);
    return (_jsxs(_Fragment, { children: [_jsxs(CustomDrawer, { open: open, onClose: handleCloseAlerts, sx: {
                    '.MuiDrawer-anchorRight,.MuiDrawer-paper': {
                        right: 16,
                        height: 'calc(100dvh - 32px)',
                        top: 16,
                        zIndex: 500,
                        borderRadius: 1.5,
                        width: { xs: '100%', sm: 500 }
                    }
                }, children: [_jsxs(Box, { sx: {
                            ...between,
                            pl: 2.5,
                            pr: 1,
                            py: 2,
                            borderBottom: (theme) => `1px solid ${theme.palette.divider}`
                        }, children: [_jsx(Box, { display: 'flex', flexDirection: 'row', gap: '10px', alignItems: 'center', children: _jsx(Typography, { variant: 'h6', color: 'text.primary', children: 'Alerts' }) }), _jsx(IconButton, { onClick: handleCloseAlerts, children: _jsx(DismissRegular, { fontSize: 18, color: theme.palette.error.main }) })] }), _jsx(SectionHeader, { title: 'Alerts List', showRangeSlider: false, setSortValue: setSortValue, setFilterValues: setFilterValues, sortOptions: [], buttonSortOptions: [], haveFilter: false, haveSorting: false, sortValue: sortValue, filterValues: filterValues }), _jsxs(Box, { sx: { ...colCenter, px: 2.1, py: 1, gap: 1 }, children: [_jsx(Button, { variant: activeFilter === 'All' ? 'contained' : 'soft', color: 'inherit', size: 'small', sx: { borderRadius: '100px' }, onClick: () => setActiveFilter('All'), children: "All" }), _jsx(Button, { size: 'small', sx: { borderRadius: '100px' }, variant: activeFilter === 'Critical' ? 'contained' : 'soft', color: 'inherit', onClick: () => setActiveFilter('Critical'), children: "Critical" })] }), _jsx(Box, { sx: {
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            zIndex: 10,
                            width: '100%',
                            height: '100%',
                            display: isLoading ? 'flex' : 'none',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }, children: _jsx("img", { src: '/assets/svgs/loader.svg', width: 50, height: 50, alt: 'loader' }) }), _jsx(Box, { sx: ContentContainerStyles, className: 'alerts-content-container', children: FilteredAlert && FilteredAlert.length > 0
                            ? FilteredAlert.map((alert) => (_jsx(IncidentTile, { showImagePreviewIcon: false, incidentId: alert.incidentId, onAlertClick: handleAlertTileClick, variant: 'alert', date: formatDMY(alert.incidentDate), isRead: alert.isRead, score: alert.totalScore, time: alert.incidentTime, imgSrc: alert.imageUrl, title: alert.licensePlate, venue: alert.location, legend: alert.legend })))
                            : !isLoading && (_jsx(Typography, { mt: 5, textAlign: 'center', variant: 'body2', children: "No alerts available" })) }), _jsx(Button, { variant: 'text', onClick: () => {
                            navigate('/incidents');
                            handleCloseAlerts();
                        }, color: 'primary', endIcon: _jsx(ArrowRight24Regular, { fontSize: '20px' }), sx: { marginTop: 'auto', mb: 1 }, children: "Go to Incidents" })] }), _jsx(IncidentPreviewDrawer, { open: alertDetails, onClose: () => setalertDetails(false) })] }));
};
export default Alerts;
